import React from 'react';
import { Button, SpaceBetween, Wizard } from '@cloudscape-design/components';
import './WorkflowWizard.css';

export function WorkflowExitActions({ onReturn, disabled = false, primary = true, children, returnLabel = 'Exit' }) {
  return <div className="path-workflow-completion-actions" data-workflow-completion-actions={primary ? 'true' : undefined}>
    <SpaceBetween direction="horizontal" size="xs">
      {children}
      <Button variant={primary ? 'primary' : 'link'} disabled={disabled} onClick={onReturn}>{returnLabel}</Button>
    </SpaceBetween>
  </div>;
}

// Keep Cloudscape's step navigation, but give a finished task its own footer.
// A missing submit handler is never presented as a clickable status label.
export default function WorkflowWizard({
  taskComplete = false,
  showReturnAction = false,
  hasInlineActions = false,
  secondaryActions,
  onReturn,
  returnLabel = 'Exit',
  activeStepIndex = 0,
  steps,
  onNavigate,
  onSubmit,
  onCancel,
  isLoadingNextStep,
  submitButtonText,
  className = '',
  ...props
}) {
  const showCompletionFooter = taskComplete || hasInlineActions;
  const displaySteps = showCompletionFooter ? steps.map((step, index) => index !== activeStepIndex ? step : {
    ...step,
    content: <SpaceBetween size="l">
      {step.content}
      <WorkflowExitActions onReturn={onReturn} disabled={isLoadingNextStep} primary={!hasInlineActions} returnLabel={returnLabel}>
        {activeStepIndex > 0 && <Button disabled={isLoadingNextStep} onClick={() => onNavigate?.({ detail: {
          requestedStepIndex: activeStepIndex - 1, reason: 'previous',
        } })}>Previous</Button>}
      </WorkflowExitActions>
    </SpaceBetween>,
  }) : steps;
  return <Wizard
    {...props}
    className={`path-workflow-wizard ${!onCancel ? 'path-workflow-no-cancel' : ''} ${showCompletionFooter ? 'path-workflow-complete' : ''} ${className}`}
    activeStepIndex={activeStepIndex}
    steps={displaySteps}
    onNavigate={isLoadingNextStep ? undefined : onNavigate}
    onCancel={isLoadingNextStep ? undefined : onCancel}
    secondaryActions={showReturnAction && !showCompletionFooter && (activeStepIndex < steps.length - 1 || onSubmit)
      ? <Button variant="link" onClick={onReturn} disabled={isLoadingNextStep}>{returnLabel}</Button>
      : secondaryActions}
    onSubmit={isLoadingNextStep ? undefined : (onSubmit || onReturn)}
    submitButtonText={onSubmit || isLoadingNextStep ? submitButtonText : returnLabel}
    isLoadingNextStep={isLoadingNextStep}
  />;
}
